import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { fmtIDR, FUEL_META } from "@/lib/format";
import { Save } from "lucide-react";

const Harga = () => {
  const [fuels, setFuels] = useState([]);
  useEffect(() => { api.get("/fuels").then(r => setFuels(r.data)); }, []);

  const update = (code, key, val) => setFuels(prev => prev.map(f => f.code === code ? { ...f, [key]: val } : f));

  const save = async (f) => {
    try {
      await api.put(`/fuels/${f.code}`, { buy_price: parseFloat(f.buy_price), sell_price: parseFloat(f.sell_price) });
      toast.success(`Harga ${FUEL_META[f.code].name} disimpan`);
    } catch (e) { toast.error("Gagal menyimpan"); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Pengaturan Harga BBM</h1>
        <p className="text-sm text-slate-500 mt-1">Update harga beli & jual per jenis BBM (Admin only)</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fuels.map(f => {
          const m = FUEL_META[f.code];
          const margin = (parseFloat(f.sell_price) || 0) - (parseFloat(f.buy_price) || 0);
          return (
            <Card key={f.code} className={`${m.border} border-2`}>
              <CardHeader className="pb-2">
                <div className="flex items-center gap-2">
                  <div className={`w-3 h-3 rounded-full ${m.dot}`} />
                  <CardTitle className={`text-lg font-bold ${m.text}`}>{f.name}</CardTitle>
                </div>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="grid grid-cols-2 gap-3">
                  <div className="space-y-2">
                    <Label>Harga Beli</Label>
                    <Input type="number" step="0.01" value={f.buy_price} data-testid={`price-update-${f.code.replace("_", "-")}-buy-input`}
                      onChange={(e) => update(f.code, "buy_price", e.target.value)} />
                  </div>
                  <div className="space-y-2">
                    <Label>Harga Jual</Label>
                    <Input type="number" step="0.01" value={f.sell_price} data-testid={`price-update-${f.code.replace("_", "-")}-input`}
                      onChange={(e) => update(f.code, "sell_price", e.target.value)} />
                  </div>
                </div>
                <div className="flex items-center justify-between p-3 rounded-lg bg-slate-50">
                  <span className="text-sm text-slate-600">Margin per Liter</span>
                  <span className="font-bold font-mono-fig text-emerald-700">{fmtIDR(margin)}</span>
                </div>
                <Button onClick={() => save(f)} data-testid={`price-save-${f.code}`} className="w-full bg-[#E30613] hover:bg-[#C8040F]">
                  <Save className="w-4 h-4 mr-2" />Simpan Harga
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default Harga;
